import React from 'react';
import { CheckIcon, GiftIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { SectionHeading } from './SectionHeading';
import { BONUS_VALUE, bonuses, includedTomos, PRODUCT } from '../data/content';
export function ValueStackSection() {
  return <section aria-labelledby="recibes" className="border-y-2 border-blush bg-blush-soft" data-id="element-248" data-mp="1me4h41l2zp3t">
      <div className="mx-auto max-w-page px-3 py-6 sm:px-6 sm:py-8" data-id="element-249" data-mp="tnmj3ez7sdx9">
        <Reveal data-id="element-250" data-mp="tnw7wz8iwf1d">
          <SectionHeading id="recibes" title="¿Qué recibes hoy?" data-id="element-251" data-mp="tph0wkf6vpx4" />
        </Reveal>

        <div className="mx-auto mt-4 grid max-w-4xl gap-2.5 md:grid-cols-2" data-id="element-252" data-mp="oqnokvbn24yj">
          <Reveal className="flex h-full flex-col rounded-xl border-2 border-blush bg-white p-3.5" data-id="element-253" data-mp="12pvqhvz6rr6f">
            <h3 className="text-center font-display text-[0.95rem] font-black uppercase leading-tight text-ink sm:text-base" data-id="element-254" data-mp="yl5um74j2cli">
              {PRODUCT}
            </h3>
            <ul className="mt-2.5 space-y-1.5" data-id="element-255" data-mp="2a2npsi81m3wf">
              {includedTomos.map(item => <li key={item} className="flex items-start gap-2 font-body text-[0.78rem] font-semibold leading-snug text-ink sm:text-[0.82rem]" data-id="element-256" data-mp="1ndi1ydruamjj">
                  <CheckIcon size={14} className="mt-0.5 flex-shrink-0 text-coral" strokeWidth={3} data-id="element-257" data-mp="1wd50mrt6pe8w" />
                  {item}
                </li>)}
            </ul>
          </Reveal>

          <Reveal delay={0.05} className="flex h-full flex-col rounded-xl border-2 border-gold bg-white p-3.5" data-id="element-258" data-mp="18o2dx5jp0v7j">
            <h3 className="text-center font-display text-[0.95rem] font-black uppercase leading-tight text-coral sm:text-base" data-id="element-259" data-mp="1dmdmlcy94zo6">
              Más: 5 bonos incluidos
            </h3>
            <ul className="mt-2.5 space-y-1.5" data-id="element-260" data-mp="kz9o7qtnzjld">
              {bonuses.map(bono => <li key={bono.shortTitle} className="flex items-start justify-between gap-2 font-body text-[0.76rem] leading-snug text-ink sm:text-[0.8rem]" data-id="element-261" data-mp="px2qw9vrdvgw">
                  <span className="flex items-start gap-1.5 font-semibold" data-id="element-262" data-mp="1o8ceycs4bvdk">
                    <GiftIcon size={14} className="mt-0.5 flex-shrink-0 text-gold" data-id="element-263" data-mp="220k5vnwq0s4c" />
                    {bono.shortTitle}
                  </span>
                  <span className="flex-shrink-0 text-slate line-through" data-id="element-264" data-mp="1a8ul3izytrxc">
                    {bono.value}
                  </span>
                </li>)}
            </ul>
            <div className="mt-auto pt-2.5 text-center" data-id="element-265" data-mp="1ja2lc6m1l2u2">
              <p className="text-[0.7rem] font-extrabold uppercase tracking-wide text-ink sm:text-[0.74rem]" data-id="element-266" data-mp="1jbm1zybm1fwd">
                💰 Solo los 5 bonos tienen un valor de {BONUS_VALUE}
              </p>
              <p className="mt-0.5 font-display text-base font-black uppercase leading-tight text-coral sm:text-lg" data-id="element-267" data-mp="2unmthkzuzift">
                Pero hoy no pagas {BONUS_VALUE} por los bonos. Los 5 están
                incluidos gratis con tu compra.
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>;
}